import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/success_smile.png'


const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "py-4" }
const _hoisted_3 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "px-4 text-left font-bold text-xl py-2" }, "購入完了", -1)
const _hoisted_5 = { class: "space-y-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "py-16 space-y-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "success smile",
    class: "h-1/2 w-auto m-auto"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold text-green-show" }, " 購入が完了しました！ ")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"space-y-4\"><div class=\"px-4\"><p class=\"text-lg font-bold text-green-lightShow\"> 商品発送までお待ちください </p></div><div class=\"px-4\"><p class=\"p-2 bg-gray-show text-sm font-bold\"> 商品発送が完了しましたらお知らせいたしますので、しばらくお待ちください </p></div></div>", 1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "pl-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-xs text-left border-b-2 border-green-lightShow text-green-lightShow" }, " 商品情報 ")
], -1)
const _hoisted_10 = { class: "p-4" }
const _hoisted_11 = { class: "flex space-x-2" }
const _hoisted_12 = { class: "shrink-0" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "flex flex-col justify-between" }
const _hoisted_15 = { class: "align-middle text-sm font-bold text-left line-clamp-2" }
const _hoisted_16 = { class: "text-xs text-left line-clamp-2" }
const _hoisted_17 = { class: "py-2" }
const _hoisted_18 = { class: "flex space-x-4 text-left border-b justify-between" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm align-middle" }, "支払い金額", -1)
const _hoisted_20 = { class: "text-green-lightShow text-lg font-bold align-middle" }
const _hoisted_21 = { class: "flex space-x-4 text-left border-b justify-between" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm align-middle ml-4" }, "優待価格", -1)
const _hoisted_23 = { class: "text-green-lightShow text-sm align-middle mr-2" }
const _hoisted_24 = { class: "flex space-x-4 text-left border-b justify-between" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm align-middle ml-4" }, "追加料金", -1)
const _hoisted_26 = { class: "text-green-lightShow text-sm align-middle mr-2" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text-green-lightShow text-lg font-bold align-middle" }, " コンシェルジュの指示にしたがって決済してください ", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "pl-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-xs text-left border-b-2 border-green-lightShow text-green-lightShow" }, " 支払い情報 ")
], -1)
const _hoisted_33 = { class: "p-4 space-y-4" }
const _hoisted_34 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-4 text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "支払い方法"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "カード（一括払い）")
], -1)
const _hoisted_36 = { class: "flex space-x-4 text-left" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "カード情報", -1)
const _hoisted_38 = { class: "text-sm" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500 text-sm text-left" }, " 支払い情報が設定されていません。 ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-black text-xs text-left mt-1" }, " 「支払い情報を変更する」ボタンから登録・変更をおこなってください ", -1)
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "text-green-lightShow text-base" }, " 支払い情報を変更する ", -1)
const _hoisted_44 = { key: 0 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "pl-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-xs text-left border-b-2 border-green-lightShow text-green-lightShow" }, " 発送情報 ")
], -1)
const _hoisted_46 = { class: "p-4 space-y-4" }
const _hoisted_47 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_48 = { class: "flex space-x-4 text-left" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "お名前", -1)
const _hoisted_50 = { class: "text-sm" }
const _hoisted_51 = { class: "flex space-x-4 text-left" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "発送先", -1)
const _hoisted_53 = { class: "text-sm" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = { key: 1 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500 text-sm text-left" }, " 発送情報が設定されていません。 ", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("p", { class: "text-black text-xs text-left mt-1" }, " 「発送情報を変更する」ボタンから登録・変更をおこなってください ", -1)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", { class: "text-green-lightShow text-base" }, " 発送情報を変更する ", -1)
const _hoisted_60 = { class: "sticky bottom-0 px-4 pb-6 pt-2 bg-gray-lightShow" }
const _hoisted_61 = { class: "space-y-2" }
const _hoisted_62 = { class: "bg-white py-2 px-4 rounded shadow" }
const _hoisted_63 = { class: "flex justify-between" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = { class: "text-sm font-bold pb-2" }
const _hoisted_66 = { class: "text-sm" }
const _hoisted_67 = { class: "text-sm" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-center text-sm" }, "支払い方法を追加する", -1)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { class: "space-y-2" }
const _hoisted_71 = { class: "bg-white py-2 px-4 rounded shadow" }
const _hoisted_72 = { class: "flex justify-between" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "text-sm font-bold pb-2" }
const _hoisted_75 = { class: "text-sm" }
const _hoisted_76 = { class: "text-xs" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-center text-sm" }, "住所を追加する", -1)
const _hoisted_78 = [
  _hoisted_77
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PencilSquareIcon = _resolveComponent("PencilSquareIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (
            _ctx.voucherReserve.voucherReserveReceipt?.paymentStatus ===
            _ctx.ReservePaymentStatues.Paid
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  style: _normalizeStyle(`background-image: url(${require('@/assets/images/success_bg.png')})`),
                  class: "bg-cover bg-center"
                }, _hoisted_7, 4),
                _hoisted_8
              ])
            ]))
          : _createCommentVNode("", true),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "flex justify-between",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goVoucherDetail()))
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("img", {
                  src: _ctx.voucherReserve.voucher?.images[0].imageUrl,
                  alt: "",
                  class: "h-20 w-20 object-cover"
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.voucherReserve.voucher?.name), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.voucherReserve.createDate
                        ? `受付日時：${_ctx.ymd(_ctx.voucherReserve.createDate)}`
                        : ``), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", _hoisted_20, " ￥" + _toDisplayString(_ctx.voucherReserve.totalPrice.toLocaleString()), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("span", _hoisted_23, "￥" + _toDisplayString(_ctx.voucherReserve.voucher?.discountedPrice.toLocaleString()), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("span", _hoisted_26, "￥" + _toDisplayString(_ctx.voucherReserve.additionalCost.toLocaleString()), 1)
            ])
          ])
        ])
      ]),
      (_ctx.voucherReserve.isExternalPayment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
            (
            _ctx.voucherReserve.voucherReserveReceipt?.paymentStatus !==
            _ctx.ReservePaymentStatues.Paid
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", null, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, [
                      (_ctx.payVoucherReserveInfo?.paymentMethod)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("div", _hoisted_36, [
                              _hoisted_37,
                              _createElementVNode("p", _hoisted_38, " ************ " + _toDisplayString(_ctx.payVoucherReserveInfo?.paymentMethod?.last4) + " (" + _toDisplayString(_ctx.payVoucherReserveInfo?.paymentMethod?.brand) + ") ", 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_42)),
                      _createElementVNode("div", {
                        class: "rounded border-2 border-green-lightShow py-2 flex justify-center space-x-2",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openUserPaymentMethodsPopup && _ctx.openUserPaymentMethodsPopup(...args)))
                      }, [
                        _createVNode(_component_PencilSquareIcon, { class: "w-6 h-6 text-green-lightShow" }),
                        _hoisted_43
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (!_ctx.voucherReserve?.influencerAddressId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            (_ctx.payVoucherReserveInfo?.address)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _hoisted_49,
                                    _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.payVoucherReserveInfo?.address?.name), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_51, [
                                    _hoisted_52,
                                    _createElementVNode("p", _hoisted_53, [
                                      _createTextVNode(_toDisplayString(_ctx.payVoucherReserveInfo?.address?.zipCode), 1),
                                      _hoisted_54,
                                      _createTextVNode(_toDisplayString(_ctx.payVoucherReserveInfo?.address?.cityName) + _toDisplayString(_ctx.payVoucherReserveInfo?.address?.streetName) + _toDisplayString(_ctx.payVoucherReserveInfo?.address?.buildingName), 1)
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_58)),
                            _createElementVNode("div", {
                              class: "rounded border-2 border-green-lightShow py-2 flex justify-center space-x-2",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openUserAddressesPopup && _ctx.openUserAddressesPopup(...args)))
                            }, [
                              _createVNode(_component_PencilSquareIcon, { class: "w-6 h-6 text-green-lightShow" }),
                              _hoisted_59
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: _normalizeClass([_ctx.isValid ? '' : 'opacity-50', "text-center block w-full items-center rounded-md border border-transparent bg-green-show px-6 py-2 text-base font-medium text-white shadow-sm"]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isValid ? _ctx.onSubmit() : ''))
                      }, " 決済する ", 2)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_van_popup, {
        show: _ctx.isShowPaymentMethods,
        "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isShowPaymentMethods) = $event)),
        position: "bottom",
        style: {height: '90%'},
        closeable: true,
        round: true,
        class: "bg-gray-lightShow py-12 px-4"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_61, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userPaymentMethods, (paymentMethod) => {
              return (_openBlock(), _createElementBlock("div", {
                key: paymentMethod.paymentMethodId
              }, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", {
                      class: "flex grow space-x-2 text-left",
                      onClick: ($event: any) => (_ctx.setPaymentMethod(paymentMethod))
                    }, [
                      _createVNode(_component_CheckIcon, {
                        class: _normalizeClass(["w-6 h-6 my-auto text-green-lightShow", 
                      _ctx.activePaymentMethodId === paymentMethod.paymentMethodId
                        ? ''
                        : 'invisible'
                    ])
                      }, null, 8, ["class"]),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_65, _toDisplayString(paymentMethod.brand), 1),
                        _createElementVNode("p", _hoisted_66, "末尾 ****" + _toDisplayString(paymentMethod.last4), 1),
                        _createElementVNode("p", _hoisted_67, " 有効期限 " + _toDisplayString(paymentMethod.exp_month) + "/" + _toDisplayString(paymentMethod.exp_year), 1)
                      ])
                    ], 8, _hoisted_64)
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("button", {
              class: "bg-green-show w-full rounded-md py-3",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goPaymentMethodList && _ctx.goPaymentMethodList(...args)))
            }, _hoisted_69)
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_van_popup, {
        show: _ctx.isShowAddresses,
        "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isShowAddresses) = $event)),
        position: "bottom",
        style: {height: '90%'},
        closeable: true,
        round: true,
        class: "bg-gray-lightShow py-12 px-4"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_70, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userAddresses, (userAddress) => {
              return (_openBlock(), _createElementBlock("div", {
                key: userAddress.addressId
              }, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", {
                      class: "text-left flex space-x-2 grow",
                      onClick: ($event: any) => (_ctx.setAddress(userAddress))
                    }, [
                      _createVNode(_component_CheckIcon, {
                        class: _normalizeClass(["w-6 h-6 my-auto text-green-lightShow", 
                      _ctx.activeAddressId === userAddress.addressId
                        ? ''
                        : 'invisible'
                    ])
                      }, null, 8, ["class"]),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_74, _toDisplayString(userAddress.name), 1),
                        _createElementVNode("p", _hoisted_75, _toDisplayString(userAddress.zipCode), 1),
                        _createElementVNode("p", _hoisted_76, _toDisplayString(userAddress.cityName) + _toDisplayString(userAddress.streetName) + _toDisplayString(userAddress.buildingName), 1)
                      ])
                    ], 8, _hoisted_73)
                  ])
                ])
              ]))
            }), 128)),
            _createElementVNode("button", {
              class: "bg-green-show w-full rounded-md py-3",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goAddressList && _ctx.goAddressList(...args)))
            }, _hoisted_78)
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ])
  ]))
}